import * as React from 'react';
import { Link } from 'react-router-dom';
// MUI
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

// In Project Imports
import logo from '../assets/logo_nBG.png';

const pages = [
  { name: 'หน้าแรก', path: '/' },
  { name: 'สินค้า', path: 'products' },
  { name: 'แคตตาล็อก', path: 'catalogs' },
  { name: 'เกี่ยวกับเรา', path: 'about' },
  { name: 'ติดต่อเรา', path: 'contact' },
  
];

function NavBar() {
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpenDrawer(open);
  };

  const drawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {pages.map((page) => (
          <ListItem key={page.name} disablePadding>
            <ListItemButton component={Link} to={page.path}>
              <ListItemText primary={page.name}  sx={{
            fontSize: '1.2rem', // or '20px', etc.
            fontWeight: 'bold', // Optional: for added emphasis
          }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <AppBar position="fixed" sx={{ top: '25px' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Logo and Name Section */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img src={logo} width={60} alt="Logo" style={{ display: window.innerWidth < 600 ? 'none' : 'block' }}/>
            <Typography
              variant="h5"
              noWrap
              component={Link}
              to="/"
              sx={{
                mr: 2,
                fontFamily: 'monospace',
                fontWeight: 800,
                letterSpacing: '.3rem',
                color: 'white',
                textDecoration: 'none',
                paddingLeft: 2,
                display: { sm: 'flex' }, // Hide on small screens and below
              }}
            >
              HOPBON PREMIUM
            </Typography>
          </Box>

          {/* Mobile Drawer Button */}
          <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={openDrawer}
              onClose={toggleDrawer(false)}
            >
              {drawerList}
            </Drawer>
          </Box>

          {/* Desktop Menu Buttons */}
          <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                component={Link}
                to={page.path}
                sx={{ mx: 1, color: 'white', fontSize: '1.2rem' }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default NavBar;
